import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: end;
  width: 50%;

  .ant-form-item-no-colon {
    display: flex;
    gap: 4px;
    font-weight: 600;
    font-size: 13px;
    color: black;
  }

  .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector,
  .ant-picker-outlined {
    border-color: #d9d9d9;
  }

  .ant-picker:hover {
    box-shadow: none;
  }

  .date {
    flex: 3;
  }

  .time {
    flex: 2;
    width: 100%;
    margin-bottom: 10px;

    .ant-picker-outlined {
      height: 38px;
      border-color: #d9d9d9;
    }
  }
`
